import { useQuery } from '@tanstack/react-query';
import { endpoints, ID, withSideload } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';

export const QUERY_KEY_SPLIT_ANNOTATION = 'document-split-annotation';

/**
 * Read model of everything the splitting screen needs about the annotation it
 * splits. Fetched through the list endpoint (the only one supporting
 * sideloads), so the whole read is a single request.
 */
export const useAnnotation = (annotationId: ID | undefined) =>
  useQuery({
    queryKey: [QUERY_KEY_SPLIT_ANNOTATION, annotationId] as const,
    queryFn: async () => {
      const response = await api.request(
        withSideload(endpoints.annotations.list({ id: [annotationId ?? 0] }), {
          documents: true,
          pages: true,
          relations: true,
        })
      );

      const annotation = response.results[0];

      if (!annotation) {
        throw new Error(`Annotation ${annotationId} was not found.`);
      }

      return {
        annotation,
        // the filename lives on the document, not on the annotation
        document: response.documents[0],
        pages: [...response.pages].sort((a, b) => a.number - b.number),
        relations: response.relations,
      };
    },
    enabled: annotationId !== undefined,
  });
